'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iconAliases = require('icons/iconAliases');

var _iconAliases2 = _interopRequireDefault(_iconAliases);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _IconConstants = require('./IconConstants');

var _iconName = require('../utils/propTypes/iconName');

var _Memoize = require('../core/Memoize');

var _SafePureComponent2 = require('../core/SafePureComponent');

var _SafePureComponent3 = _interopRequireDefault(_SafePureComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getIconClassName = function getIconClassName(size, measuredSize) {
  size = size || measuredSize;
  if (size === null) {
    size = 'high';
  } else if (_IconConstants.ICON_SIZES[size]) {
    size = _IconConstants.ICON_SIZES[size] <= _IconConstants.ICON_SIZES.small ? 'low' : 'high';
  } else if (typeof size === 'number') {
    size = size <= _IconConstants.ICON_SIZES.small ? 'low' : 'high';
  }
  return 'private-icon__' + size;
};

var getComputedFontSize = function getComputedFontSize(size) {
  if (!size) return null;

  if (_IconConstants.ICON_SIZES.hasOwnProperty(size)) {
    return _IconConstants.ICON_SIZES[size];
  }

  return size;
};

var getStyle = function getStyle(style, color, size) {
  return _extends({
    color: color
  }, style, {
    fontSize: getComputedFontSize(size)
  });
};

var UIIcon = function (_SafePureComponent) {
  _inherits(UIIcon, _SafePureComponent);

  function UIIcon(props) {
    _classCallCheck(this, UIIcon);

    var _this = _possibleConstructorReturn(this, (UIIcon.__proto__ || Object.getPrototypeOf(UIIcon)).call(this, props));

    _this.state = {
      measuredSize: null
    };
    _this._getStyle = (0, _Memoize.memoizeLastResult)(getStyle);
    _this.measureSize = _this.measureSize.bind(_this);
    _this.refCallback = _this.refCallback.bind(_this);
    return _this;
  }

  _createClass(UIIcon, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      setTimeout(this.measureSize, 0);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevState.measuredSize === this.state.measuredSize) {
        this.measureSize();
      }
    }
  }, {
    key: 'measureSize',
    value: function measureSize() {
      if (!this._el || this.props.size) return;
      var styles = window.getComputedStyle(this._el, null);
      if (styles == null) {
        // See #4208
        return;
      }
      var measuredSize = parseInt(styles.fontSize, 10);
      if (measuredSize !== this.state.measuredSize) {
        this.setState({
          measuredSize: measuredSize
        });
      }
    }
  }, {
    key: 'refCallback',
    value: function refCallback(ref) {
      this._el = ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          className = _props.className,
          name = _props.name,
          style = _props.style,
          size = _props.size,
          rest = _objectWithoutProperties(_props, ['color', 'className', 'name', 'style', 'size']);

      var measuredSize = this.state.measuredSize;

      var computedName = _iconAliases2.default[name] || name;
      var computedClassName = (0, _classNames2.default)('private-icon', getIconClassName(size, measuredSize), className);

      return _react2.default.createElement(
        'span',
        _extends({}, rest, {
          'aria-hidden': true,
          className: computedClassName,
          ref: this.refCallback,
          style: this._getStyle(style, color, size)
        }),
        computedName
      );
    }
  }]);

  return UIIcon;
}(_SafePureComponent3.default);

exports.default = UIIcon;


UIIcon.propTypes = {
  color: _react.PropTypes.string,
  className: _react.PropTypes.string,
  name: (0, _iconName.getIconNamePropType)().isRequired,
  size: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(Object.keys(_IconConstants.ICON_SIZES)), _react.PropTypes.number]),
  style: _react.PropTypes.object
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/icon/UIIcon.js
// module id = 29
// module chunks = 2 3